import { useEffect, useRef, useState } from 'react'

export type AppSelectOption = { value: string; label: string }

export function AppSelect({ value, options, label, onChange, disabled = false }: {
  value: string
  options: AppSelectOption[]
  label: string
  onChange: (value: string) => void
  disabled?: boolean
}) {
  const [open, setOpen] = useState(false)
  const root = useRef<HTMLDivElement>(null)
  const selected = options.find(option => option.value === value)
  useEffect(() => {
    const close = (event: PointerEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false)
    }
    const closeWithKeyboard = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', close)
    document.addEventListener('keydown', closeWithKeyboard)
    return () => {
      document.removeEventListener('pointerdown', close)
      document.removeEventListener('keydown', closeWithKeyboard)
    }
  }, [])
  return <div className="app-select" ref={root}>
    <button type="button" className="app-select-trigger" aria-label={label}
      aria-haspopup="listbox" aria-expanded={open} disabled={disabled}
      onClick={() => setOpen(current => !current)}>
      <span className="app-select-value">{selected?.label ?? '—'}</span><svg aria-hidden="true" className="app-select-chevron" viewBox="0 0 20 20"><path d="m5.5 7.5 4.5 4.5 4.5-4.5"/></svg>
    </button>
    {open && <div className="app-select-options" role="listbox" aria-label={label}>
      {options.map(option => <button type="button" role="option"
        aria-selected={option.value === value} className={option.value === value ? 'selected' : undefined}
        key={option.value} onClick={() => { onChange(option.value); setOpen(false) }}>
        <span>{option.label}</span>{option.value === value && <span aria-hidden="true">✓</span>}
      </button>)}
    </div>}
  </div>
}
